import { Settings } from '@mui/icons-material';
import { InvoiceLimitManager } from '../modules';
import { RouteType } from './types';
import { routePaths } from './routePaths';

const SubscriptionLimit: RouteType = {
  exact: true,
  icon: Settings,
  path: routePaths.subscriptionLimit,
  title: 'Subscription Limits',
  component: () => <InvoiceLimitManager />,
  permission: 'canModifyInvoiceLimit',
};

export default SubscriptionLimit;
